import "./i18n";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { CountryProvider } from "./context/CountryContext";
import { ZoneProvider } from "./context/ZoneContext";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import PassengerDashboard from "./pages/PassengerDashboard";
import DriverDashboard from "./pages/DriverDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import RecruitDriver from "./pages/RecruitDriver";
import AgentSpace from "./pages/AgentSpace";
import PayLanding from "./pages/PayLanding";
import PaySuccess from "./pages/PaySuccess";
import RideConfirmed from "./pages/RideConfirmed";
import Privacy from "./pages/Privacy";
import TripTracker from "./pages/TripTracker";
import { InstallBanner } from "./components/InstallBanner";
import { VoiceProvider } from "./components/VoiceProvider";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { BrandMeta } from "./components/BrandMeta";

function Protected({ role, children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-10 h-10 rounded-full border-4 border-[#D94F2B] border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to={`/auth?role=${role || "passenger"}`} replace />;
  if (role && user.role !== role && !user.is_super_admin) return <Navigate to={`/${user.role}`} replace />;
  return children;
}

function App() {
  return (
    <div className="App min-h-screen">
      <AuthProvider>
        <ZoneProvider>
        <CountryProvider>
          <Toaster position="top-center" richColors />
          <BrandMeta />
          <ErrorBoundary>
          <BrowserRouter>
            <VoiceProvider>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/inscription" element={<Auth />} />
              <Route path="/recruter" element={<RecruitDriver />} />
              <Route path="/pay" element={<PayLanding />} />
              <Route path="/pay/merci" element={<PaySuccess />} />
              <Route path="/equipe" element={<AgentSpace />} />
              <Route path="/agent" element={<AgentSpace />} />
              <Route path="/confidentialite" element={<Privacy />} />
              <Route path="/suivi/:token" element={<TripTracker />} />
              <Route path="/course/confirmee" element={<Protected role="passenger"><RideConfirmed /></Protected>} />
              <Route path="/passenger" element={<Protected role="passenger"><PassengerDashboard /></Protected>} />
              <Route path="/driver" element={<Protected role="driver"><DriverDashboard /></Protected>} />
              <Route path="/admin" element={<Protected role="admin"><AdminDashboard /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            </VoiceProvider>
          </BrowserRouter>
          </ErrorBoundary>
          <InstallBanner />
        </CountryProvider>
        </ZoneProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
